module.exports = __webpack_public_path__ + "img/contato.e0d1d4cf.png";